export const stateMismatchModalText = {
  title: 'Customer Address Updated',
  description: 'The customer address has been updated and the provider selection is no longer valid.',
  previousStateLabel: 'Previous state:',
  currentStateLabel: 'Current state:',
  notSpecified: 'Not specified',
  instruction: 'Please click below to update available providers for this customer.',
  buttonText: 'Update Providers',
  toastMessage: (state: string) => `Customer state was updated. Please select a new time for ${state}.`,
} as const
